"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var LocationPropType = _propTypes["default"].shape({
  _id: _propTypes["default"].number.isRequired,
  name: _propTypes["default"].string,
  city: _propTypes["default"].string,
  street: _propTypes["default"].string
});
exports.LocationPropType = LocationPropType;